import React from 'react';
import ContactsCardNotes from "../../widgets/raet/ContactsCardNotes";

const MaintableContactsPage = () => {

    return (
        <div>
            <ContactsCardNotes/>
        </div>
    );
};

export default MaintableContactsPage;
